// services/profileService.js - сервис для работы с профилем

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

class ProfileService {
    constructor() {
        this.token = localStorage.getItem('auth_token');
    }

    getHeaders() {
        const headers = {
            'Content-Type': 'application/json',
        };

        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }

        return headers;
    }

    updateToken() {
        this.token = localStorage.getItem('auth_token');
    }

    // Получение данных профиля
    async getProfile() {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/profile`, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка получения профиля'
            };
        } catch (error) {
            console.error('Get profile error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Обновление основных данных профиля
    async updateProfile(profileData) {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/profile`, {
                method: 'PUT',
                headers: this.getHeaders(),
                body: JSON.stringify(profileData),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка обновления профиля',
                errors: data.errors || null
            };
        } catch (error) {
            console.error('Update profile error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Обновление пароля
    async updatePassword(passwordData) {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/profile/password`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(passwordData),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, message: data.message };
            }

            return {
                success: false,
                message: data.message || 'Ошибка изменения пароля',
                errors: data.errors || null
            };
        } catch (error) {
            console.error('Update password error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Загрузка аватара
    async updateAvatar(file) {
        try {
            this.updateToken();

            const formData = new FormData();
            formData.append('avatar', file);

            const response = await fetch(`${API_BASE_URL}/profile/avatar`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.token}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка загрузки аватара'
            };
        } catch (error) {
            console.error('Upload avatar error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Обновление кошелька
    async updateWallet(walletData) {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/profile/wallet`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(walletData),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка обновления кошелька',
                errors: data.errors || null
            };
        } catch (error) {
            console.error('Update wallet error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Генерация кода для Telegram
    async generateTelegramCode() {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/profile/telegram/generate-code`, {
                method: 'POST',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка генерации кода'
            };
        } catch (error) {
            console.error('Generate telegram code error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Подключение Telegram
    async connectTelegram(telegramData) {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/profile/telegram/connect`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(telegramData),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка подключения Telegram',
                errors: data.errors || null
            };
        } catch (error) {
            console.error('Connect telegram error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }
}

export const profileService = new ProfileService();
